import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Operation } from 'fast-json-patch'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { ClubModel } from '../../types/court/court'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useUpdateClub() {
  const { t } = useTranslation(['clubs', 'exceptions'])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)
  const { authInfo } = useAuth()
  const { patcher } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const resetState = () => {
    setLoading(false)
    setError(null)
    setSuccess(null)
  }

  const updateClub = async (clubId: number, patch: Operation[]) => {
    setLoading(true)
    setError(null)
    setSuccess(null)
    try {
      const updatedClub = await patcher<ClubModel>(
        `${CONFIG.BOUNCE_API}/api/v1/clubs/${clubId}`,
        patch,
        'application/json-patch+json'
      )
      if (!updatedClub) {
        return
      }
      setSuccess(t('clubs:clubs.successfully-updated'))
      return updatedClub
    } catch (caughtError) {
      console.error(caughtError)
      if (caughtError instanceof ApiError) {
        setError(getErrorMessage(caughtError.data))
        return
      }
      setError(t('exceptions:unknown'))
    } finally {
      setLoading(false)
    }
  }

  return {
    updateClub,
    loading,
    error,
    success,
    resetState,
  }
}
